import { Dispatch } from "react";

import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  EventGuestlistBlockService,
  EventInfoBlockService,
  EventPeopleBlockService,
  EventScheduleBlockService,
  EventTravelBlockService,
} from "Bands/services";
import { EventAccommodationBlockService } from "Bands/services/EventAccommodationBlockService";
import { BAND_ACTIONS } from "Bands/types";

export const dispatchDeleteEventBlock = (
  dispatch: Dispatch<any>,
  deleteEventBlockId: string,
  eventBlockType: string
) => {
  dispatch(
    deleteEventBlock({
      deleteEventBlockId,
      eventBlockType,
    })
  );
};

export const deleteEventBlock = createAsyncThunk(
  BAND_ACTIONS.deleteEventBlock,
  async (
    { deleteEventBlockId, eventBlockType }: { deleteEventBlockId: string; eventBlockType: string },
    { rejectWithValue }
  ) => {
    try {
      switch (eventBlockType) {
        case "eventPeopleBlock":
          await EventPeopleBlockService.deleteBlock(deleteEventBlockId);
          break;
        case "eventScheduleBlock":
          await EventScheduleBlockService.deleteBlock(deleteEventBlockId);
          break;
        case "eventTravelBlock":
          await EventTravelBlockService.deleteBlock(deleteEventBlockId);
          break;
        case "eventAccommodationBlock":
          await EventAccommodationBlockService.deleteBlock(deleteEventBlockId);
          break;
        case "eventGuestlistBlock":
          await EventGuestlistBlockService.deleteBlock(deleteEventBlockId);
          break;
        case "eventInfoBlock":
          await EventInfoBlockService.deleteBlock(deleteEventBlockId);
          break;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
